<template>
  <div>
    <vapp-header btnMenu :tabList="tabItem"></vapp-header>
    <div class="list-group-fnc" v-if="contacts.length">
      <div
      v-for="(contact, index) in contacts" :key="index"
      class="row no-gutters p-3 justify-content-between">
        <div class="col-6" @click="editContact(contact)">
          <h5 class="mb-3 font-weight-bold">{{ contact.entity.display_name }}</h5>
          <h6 class="mb-3"><img class="img-icon" src="@/assets/images/ct-icon-company.svg">{{ contact.contactpersons[0] ? contact.entity.name : '-' }}</h6>
          <h6 class="mb-3"><img class="img-icon" src="@/assets/images/ct-icon-telephone.svg"> {{ contact.entity.phone_no ? contact.entity.phone_no : 'Not provided'}}</h6>
          <h6 v-if="contact.addresses.length">
            <img class="img-icon" src="@/assets/images/ct-icon-map.svg">
            {{ contact.addresses[0].text }}
          </h6>
          <h6 v-else>
            <img class="img-icon" src="@/assets/images/ct-icon-map.svg">
            Not provided
          </h6>
        </div>
        <div class="btn-group ">
          <span v-if= "contact.entity.email"><b-link class="btn-circle btn-green" @click="openEmail(contact)"><img  src="@/assets/images/ct-btn-mail.svg"></b-link></span>
          <!-- <span v-else><b-link class="btn-circle btn-white"></b-link></span> -->
          <span v-if = "contact.entity.address"><b-link class="btn-circle btn-purple" @click="openMap(contact)"><img src="@/assets/images/ct-btn-map.svg"></b-link></span>
          <!-- <span v-else><b-link class="btn-circle btn-white"></b-link></span> -->
          <span v-if = "contact.entity.phone_no"><b-link class="btn-circle btn-red" @click="openPhoneDial(contact)"><img src="@/assets/images/ct-btn-telephone.svg"></b-link></span>
          <!-- <span v-else><b-link class="btn-circle btn-white"></b-link></span> -->
        </div>
      </div>
    <div class="bottomSpace"></div>
    </div>

    <div v-else-if="contacts.length === 0 && is_loading_api === false">
      <md-empty-state class="empty-state" v-if="!num_contacts && current_route_param == 'all'">
        <h1>Let's start adding new contact!</h1>
        <p>Create new contact by clicking this button</p>
        <img src="@/assets/images/ic_arrow_point.svg">
      </md-empty-state>
      <md-empty-state class="empty-state" v-else-if="!num_contacts && current_route_param == 'customers'">
        <h1>No customers added</h1>
        <p>Create new contact by clicking this button</p>
        <img src="@/assets/images/ic_arrow_point.svg">
      </md-empty-state>
      <md-empty-state class="empty-state" v-else-if="!num_contacts && current_route_param == 'suppliers'">
        <h1>No suppliers added</h1>
        <p>Create new contact by clicking this button</p>
        <img src="@/assets/images/ic_arrow_point.svg">
      </md-empty-state>
    </div>

  <vapp-right-panel :thepage="'/create_business'"></vapp-right-panel>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  data() {
    return {
      contacts: [],
      all_contacts: [],
      all_customers: [],
      all_suppliers: [],
      company_id: null,
      company_ids: [],
      errored: false,
      loading: true,
      tabItem: {
        name: 'contact',
        params: ['all', 'customers', 'suppliers']
      },
      is_loading_api: false,
    }
  },
  computed: {
    ...mapState('company', ['selectedCompany']),
    num_contacts: function() {
      return this.contacts.length
    },
    current_route_param: function() {
      return this.$route.params.cat
    }
  },
  mounted() {
    console.log("Mounted : Main/Contacts");
  
    //Get all contacts
    this.$root.$emit('show-loading', true);
    this.is_loading_api = true;
    this.axios
      .get("contacts?business_id=" + this.selectedCompany)
      .then(response => {
        this.$root.$emit('show-loading', false);
        this.is_loading_api = false;
        this.all_contacts = JSON.parse(JSON.stringify(response.data.contacts));

        for (var i = 0; i < this.all_contacts.length; i++) {
          if (this.all_contacts[i].is_customer == true) {
            this.all_customers.push(this.all_contacts[i])
          }
          if (this.all_contacts[i].is_supplier == true) {
            this.all_suppliers.push(this.all_contacts[i])
          }
        }
        this.contacts = this.all_contacts
    }).catch(error => {
      this.$root.$emit('show-loading', false);
      this.$generalAPIErrorHandling(error, this.$router);
    })
  },
  methods: {
    ...mapActions('contact', ['setContactBeingEdited']),
    switchTab() {
      if (this.$route.params.cat == 'all') {
        this.contacts = this.all_contacts
      } else if (this.$route.params.cat == 'customers') {
        this.contacts = this.all_customers
      } else if (this.$route.params.cat == 'suppliers') {
        this.contacts = this.all_suppliers
      }
    },
    editContact(contact) {
      this.setContactBeingEdited(contact);
      if (contact.entity.type == 0) {
        this.$router.push({ name: 'edit_person', params: { cat: contact.id } })
      } else {
        this.$router.push({ name: 'edit_business', params: { cat: contact.id } })
      }
    },
    openEmail(contact) {
      var email = contact.entity.email;
      var subject = '';
      var emailBody = '';
      if (email) {
        document.location = "mailto:"+email+"?subject="+subject+"&body="+emailBody;
      } else {
        this.$infoToast('Email not available.')
      }
    },
    openMap(contact) {
      if (contact.entity.addresses) {
        window.open("https://maps.google.com/maps?daddr=" + contact.addresses[0].text + "&amp;ll=");
      } else {
        this.$infoToast('Address not available.')
      }
    },
    openPhoneDial(contact) {
      if (contact.entity.phone_no) {
        document.location = "tel:"+contact.entity.phone_no;
      } else {
        this.$infoToast('Telephone number not available.')
      }
    }
  },
  watch: {
    '$route': 'switchTab'
  }
}
</script>
